import React, { forwardRef, memo } from "react";
import accessibilityProvider from "../../utils/accessibilityProvider";

import "./widget-card-head.css";

const WidgetCardHead = memo(
	forwardRef((props, ref) => {
		return (
			<div className={`widget-card-head`} ref={ref}>
				<div className="widget-card-head-title-container">
					<div
						className={`widget-card-head-title`}
						{...accessibilityProvider({
							role: "heading",
							name: "Customers also bought",
							level: 3,
						})}
					>
						Customers also bought
					</div>
				</div>
			</div>
		);
	})
);

export default WidgetCardHead;
